import { render, staticRenderFns } from "./InterestManagement.vue?vue&type=template&id=b4d47076&scoped=true&"
import script from "./InterestManagement.vue?vue&type=script&lang=js&"
export * from "./InterestManagement.vue?vue&type=script&lang=js&"
import style0 from "./InterestManagement.vue?vue&type=style&index=0&id=b4d47076&lang=scss&scoped=true&"
import style1 from "./InterestManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d47076",
  null
  
)

export default component.exports